import template from './app.html';
import controller from './app.controller';
import './app.less';

let appComponent = {
  template,
  controller,
  restrict: 'E',
  controllerAs: 'vm'
};

export default appComponent;



// WEBPACK FOOTER //
// ./client/app/app.component.js